import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Descriptions, Collapse, Button } from "antd";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

function App(props) {
  const { Panel } = Collapse;

  const [response, setResponse] = useState();
  const [deleted, setDeleted] = useState(false);
  const deleteAction = () => {
    Axios.delete(baseUrl + "user/delete/" + props.match.params.id)
      .then((response) => {
        setDeleted(true);
      })
      .catch(function (error) {});
  };
  useEffect(() => {
    Axios.get(baseUrl + "user/" + props.match.params.id)
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});
  }, []);
  if (deleted) {
    return <Redirect to="/users/list" />;
  }
  if (!response) {
    return <div>Loading</div>;
  }
  return (
    <div style={{ padding: "100px 0" }}>
      <Descriptions title="User Info" bordered layout="vertical">
        <Descriptions.Item label="User Id" span={3}>
          {response.user._id}
        </Descriptions.Item>
        <Descriptions.Item label="Email">
          {response.user.email}
        </Descriptions.Item>
        <Descriptions.Item label="Name">
          {response.user.firstName}
        </Descriptions.Item>
        <Descriptions.Item label="Phone Number">
          {response.user.phoneNumber}
        </Descriptions.Item>
        <Descriptions.Item label="Role">
          <p>
            {response.user.admin === true ? <div>admin</div> : <div>user</div>}
          </p>
        </Descriptions.Item>
        <Descriptions.Item label="Products" span={3}></Descriptions.Item>
      </Descriptions>
      <div style={{ paddingTop: 50 }}>
        <Link to={`/users/edit/${props.match.params.id}`}>
          <Button style={{ marginRight: "10px" }} type="primary">
            Edit
          </Button>
        </Link>

        <Button type="danger" onClick={() => deleteAction()}>
          Delete User
        </Button>
      </div>
    </div>
  );
}

export default App;
